import React from 'react'

export const Panel = ({ title, children }) => {
  return (
    <div className="dev_dash__panel">
      <div className="dev_dash__panel__heading">
        <h3 className="dev_dash__panel__heading--title">{title}</h3>
      </div>
      <div className="dev_dash__panel__body">{children}</div>
    </div>
  )
}
